import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../redux/features/auth/authSlice';
import userReducer from '../redux/features/user/userSlice';
import staffReducer from '../redux/features/staff/staffSlice';
import dailyMessageReducer from '../redux/features/dailyMessage/dailyMessageSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    staff: staffReducer,
    dailyMessage: dailyMessageReducer,
  },
});

export default store;
